import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiBell, FiMenu, FiUser } from "react-icons/fi";

const PAGE_TITLES = [
  ["/dashboard/allocation-control", "Allocation Control Center"],
  ["/dashboard/tours", "Transport operations"],
  ["/dashboard/accounts", "Accounts & fleet"],
  ["/dashboard/liveLocation", "Live operations map"],
  ["/dashboard/sessionInfo", "Driver sessions"],
  ["/dashboard/summary", "Operations summary"],
  ["/dashboard/admin", "Admin workspace"],
  ["/dashboard/history", "Driver history"],
  ["/dashboard/invoice", "Invoices"],
  ["/dashboard/charts", "Performance dashboard"],
  ["/dashboard/notification", "Notifications"],
  ["/dashboard/home", "Home"],
];

const getPageTitle = (pathname) => {
  const match = PAGE_TITLES.find(([route]) => pathname.startsWith(route));
  return match ? match[1] : "Manager workspace";
};

const AppTopbar = ({ onMenuClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const managerMobile = localStorage.getItem("managerMobile") || "Manager";

  return (
    <header className="app-topbar">
      <div className="app-topbar__left">
        <button
          type="button"
          className="app-topbar__menu-button"
          onClick={onMenuClick}
          aria-label="Open navigation"
        >
          <FiMenu aria-hidden="true" />
        </button>

        <div className="app-topbar__title-wrap">
          <span className="app-topbar__eyebrow">GOODMOVE CONTROL CENTRE</span>
          <h1 className="app-topbar__title">{getPageTitle(location.pathname)}</h1>
        </div>
      </div>

      <div className="app-topbar__actions">
        <div className="app-topbar__status" aria-label="Manager workspace active">
          <span className="app-topbar__status-dot" />
          Workspace active
        </div>

        <button
          type="button"
          className="app-topbar__icon-button"
          onClick={() => navigate("/dashboard/notification")}
          aria-label="Open notifications"
        >
          <FiBell aria-hidden="true" />
        </button>

        <div className="app-topbar__profile">
          <span className="app-topbar__avatar">
            <FiUser aria-hidden="true" />
          </span>
          <span className="app-topbar__profile-copy">
            <strong>Manager</strong>
            <small>{managerMobile}</small>
          </span>
        </div>
      </div>
    </header>
  );
};

export default AppTopbar;
